
import { DynamicForm, useApiService, withFormService } from "@art/shared-ui";
import { validators } from "@art/shared-ui";


function ArtRoleAddPage({ data, onSave, onInit }: any) {
    const apiService = useApiService();

    const formBuilder = (data: any) => {
        return [
            {
                type: 'hidden',
                id: 'id',
                value: data?.id
            },
            {
                type: "row",
                children: [
                    {
                        type: 'col',
                        classNames: ['col-12'],
                        children: [
                            {
                                id: "title",
                                label: "Role Name",
                                type: "text",
                                placeholder: "Role Name",
                                required: true,
                                value: data?.title,
                                validate: validators((value) => {
                                    if (!value || value.trim() === "") {
                                        return "Role Name is required.";
                                    }
                                    if (/[^a-zA-Z0-9 ]/.test(value)) {
                                        return "Role Name can only contain letters, numbers, and spaces.";
                                    }
                                    if (!/[a-zA-Z]/.test(value)) {
                                        return "Role Name must include at least one letter.";
                                    }
                                    if (value.length > 30) {
                                        return "Role Name cannot be longer than 30 characters.";
                                    }
                                    return null;
                                })
                            },

                        ]
                    }
                ]
            },
            {
                type: "row",
                children: [
                    {
                        type: 'col',
                        classNames: ['col-12'],
                        children: [
                            {
                                id: "description",
                                label: "Role Description",
                                type: "text",
                                placeholder: "Description",
                                marginBottom: 0,
                                required: true,
                                multiline: true,
                                rows: 3,
                                value: data?.description,
                                validate: validators((value) => {
                                    if (!value || value.trim() === "") {
                                        return "Role description is required.";
                                    }
                                    if (value.length > 100) {
                                        return "Role description cannot be longer than 100 characters.";
                                    }
                                    return null;
                                })
                            },
                        ]
                    }
                ]
            }
        ]
    };

    return <DynamicForm formBuilder={formBuilder} onInit={onInit}
        onSubmit={!data ? apiService.saveData("/roles", 'post', {
            onSuccess: () => {
                onSave();
            },
            onError: (err: any) => {
                console.log(err);
            }
        }) : apiService.saveData(`/roles/${data?.id}`, 'put', {
            onSuccess: () => {
                onSave();
            },
            onError: (err: any) => {
                console.log(err);
            }
        })} />

}

export default withFormService(ArtRoleAddPage);